module.exports = __webpack_public_path__ + "img/Weak Pendant Connection.571fd29c.png";